export default __webpack_public_path__ + "static/media/Snowmelt_2.55560b37.webm";